export const AQUA_DRAFTS_BASE_URL = "https://aqua-drafts.web.app";
export const API_BASE_URL_PRODUCTION =
  "https://kinoneconnect-okdftkfcxq-an.a.run.app/api";
export const API_BASE_URL_TEST =
  "https://test-main-backend-366805150657.asia-northeast1.run.app/api";
export const LOCAL_STORAGE_KEY = "DefaultUserOnRocketFORGE";
export const APPLICATION_VERSION = "1.2.0";
